import { nanoid, unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  ModalProps,
  notification,
  Radio,
  Row,
  Select,
  Upload,
} from 'antd'
import _ from 'lodash'
import React, {
  ReactElement,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { ItemCompletionType } from '../../completion/completionSlice'
import { CloseOutlined, LoadingOutlined, PlusOutlined } from '@ant-design/icons'
import { ThemeContext } from '../../../theme/ThemeContext'
import { RecipeItemInput } from '../../treatment/editor/components/RecipeItemInput'
import styles from './setting.module.css'
import { RecipeItemFieldInput } from '../../treatment/editor/components/RecipeItemFieldInput'
import { Settings } from '../../../models/setting'
import { selectBooleanSetting } from '../../settings/settingsSlice'
import {RecipeCategory} from "../../../models/recipe";

interface AutoExpenseModalProps {
  visible?: boolean
  title?: string
  editDetailMessage?: any
  onOk?: () => void
  onCancel?: () => void
  onSuccess?: (m?: any, v?: any) => void
}
export const AutoExpenseModal = ({
  title,
  editDetailMessage,
  onCancel,
  onOk,
  onSuccess,
  ...others
}: AutoExpenseModalProps & ModalProps): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const theme = useContext(ThemeContext)

  const [form] = Form.useForm()

  //自动生成费用下拉选中的值
  const [ZDSCFYSelectList, setZDSCFYSelectList] = useState<any[]>([])

  //自动生成费用判断是药品还是诊疗
  const [completionType, setCompletionType] = useState<any>(
    ItemCompletionType.Treatment
  )

  //用法下拉选中的值
  const [normalUseMethodSelectList, setNormalUseMethodSelectList] = useState<
    any[]
  >([])

  //用法中的 药品/诊疗下拉选中的值
  const [selectYPOrZLList, setSelectYPOrZLList] = useState<any[]>([])

  //用法中的 判断是药品还是诊疗
  const [completionTypeA, setCompletionTypeA] = useState<any>(
    ItemCompletionType.Treatment
  )

  const [ZDSCFYInput, setZDSCFYInput] = useState('')

  const [YFInputValue, setYFInputValue] = useState('')

  const [treatmentServiceIds, setTreatmentServiceIds] = useState<any>()

  const [projectDataName, setProjectDataName] = useState<any>()

  const [materialsCatalogIds, setMaterialsCatalogIds] = useState<any>()

  const [
    conditionMaterialsCatalogIds,
    setConditionMaterialsCatalogIds,
  ] = useState<any>()

  const [
    conditionTreatmentServiceIds,
    setConditionTreatmentServiceIds,
  ] = useState<any>()

  const [conditionDataName, setConditionDataName] = useState<any>()

  const [conditionUsemethod, setConditionUsemethod] = useState<any>()

  const [normalUsemethodValue, setNormalUsemethodValue] = useState<any>()

  const useSpecifiedBatch = useSelector(
    selectBooleanSetting(Settings.Recipe.UseSpecifiedBatch)
  )

  const ignoreStorage = useSelector(
    selectBooleanSetting(Settings.Recipe.IgnoreStorage)
  )

  const [isLoading, setIsLoading] = useState(false)

  // 触发条件类型状态存储
  const [state, setState] = useState(0)

  useEffect(() => {
    if (others.visible) {
      // 编辑时
      if (title == 'edit') {
        // 前端进行暂存编辑
        form.setFieldsValue({
          conditionType: editDetailMessage.conditionType,
          projectCount: editDetailMessage.projectCount || 1,
          countType: editDetailMessage?.countType,
        })
        // 自动生成费用的list
        setZDSCFYSelectList(editDetailMessage?.projectData)

        // 触发条件类型状态是药品或诊疗选中的所有list
        setSelectYPOrZLList(editDetailMessage.conditionData)

        // 触发条件类型状态是用法选中的所有用法list
        setNormalUseMethodSelectList(
          editDetailMessage.conditionUsemethod
            ? editDetailMessage.conditionUsemethod?.split(',')
            : []
        )

        // 触发条件类型状态
        setState(editDetailMessage.conditionType)
      } else if (title == 'create') {
        // 新增默认
        form.setFieldsValue({
          conditionType: 0, //触发条件类型默认用法
          countType: 0, //生成数量规则默认固定数量
        })
      }
    }
  }, [title, editDetailMessage, others.visible])

  useEffect(() => {
    // 弹窗关闭后清除所有数据
    if (!others?.visible) {
      form.resetFields()
      setZDSCFYSelectList([])
      setSelectYPOrZLList([])
      setNormalUseMethodSelectList([])
      setZDSCFYInput('')
      setYFInputValue('')
      setState(0)
    }
  }, [others?.visible])

  useEffect(() => {
    if (others?.visible) {
      if (ZDSCFYSelectList?.length) {
        // 自动生成费用中选中的治疗所有id
        const treatmentServiceIds = ZDSCFYSelectList?.filter(
          (m) => m.catalogType == 2
        )
          .map((d) => d.id)
          ?.join(',')
        // 自动生成费用中选中的药品所有id
        const materialsCatalogIds = ZDSCFYSelectList?.filter(
          (m) => m.catalogType == 1
        )
          .map((d) => d.id)
          ?.join(',')

        // 自动生成费用中选中的所有list筛选出的name
        const projectDataName = ZDSCFYSelectList?.map((m: any) => m.name)?.join(
          ','
        )
        setZDSCFYSelectList(ZDSCFYSelectList)
        setTreatmentServiceIds(treatmentServiceIds)
        setMaterialsCatalogIds(materialsCatalogIds)
        setProjectDataName(projectDataName)
      }
    }
  }, [ZDSCFYSelectList, others?.visible])

  useEffect(() => {
    if (others?.visible) {
      if (selectYPOrZLList?.length) {
        // 触发条件类型状态选择药品的所有药品id
        const conditionMaterialsCatalogIds =
          state == 1
            ? selectYPOrZLList
                ?.filter((m) => m.catalogType == 1)
                .map((d) => d.id)
                ?.join(',')
            : ''

        // 触发条件类型状态 conditionType == 1 selectYPOrZLList 药品或诊疗list筛选出的name集合
        const conditionDataName =
          state == 1 ? selectYPOrZLList?.map((m: any) => m.name)?.join(',') : ''

        // 自动生成费用中选中的药品所有id
        const conditionTreatmentServiceIds =
          state == 1
            ? selectYPOrZLList
                ?.filter((m) => m.catalogType == 2)
                .map((d) => d.id)
                ?.join(',')
            : ''

        setSelectYPOrZLList(selectYPOrZLList)
        setConditionMaterialsCatalogIds(conditionMaterialsCatalogIds)
        setConditionTreatmentServiceIds(conditionTreatmentServiceIds)
        setConditionDataName(conditionDataName)
      }
    }
  }, [selectYPOrZLList, others?.visible])

  useEffect(() => {
    if (others?.visible) {
      const conditionUsemethod = normalUseMethodSelectList?.join(',')
      setConditionUsemethod(conditionUsemethod)
    }
  }, [normalUseMethodSelectList, others?.visible])

  return (
    <>
      <Modal
        {...others}
        title={'自动生成费用' + (title == 'create' ? '添加' : '编辑')}
        width={800}
        confirmLoading={isLoading}
        cancelText='取消'
        okText='确定'
        onCancel={() => {
          onCancel && onCancel()
          form.resetFields()
        }}
        destroyOnClose
        onOk={(e) => {
          form.validateFields().then((values) => {
            if (values.conditionType == 0) {
              if (
                !normalUseMethodSelectList?.length &&
                !ZDSCFYSelectList?.length
              ) {
                notification.info({
                  message: '请填写必填项【用法】【自动生成费用】',
                })
                return
              } else if (!normalUseMethodSelectList?.length) {
                notification.info({
                  message: '请填写必填项【用法】',
                })
                return
              } else if (!ZDSCFYSelectList?.length) {
                notification.info({
                  message: '请填写必填项【自动生成费用】',
                })
                return
              }
            } else {
              if (!selectYPOrZLList?.length && !ZDSCFYSelectList?.length) {
                notification.info({
                  message: '请填写必填项【药品/诊疗项目】【自动生成费用】',
                })
                return
              } else if (!selectYPOrZLList?.length) {
                notification.info({
                  message: '请填写必填项【药品/诊疗项目】',
                })
                return
              } else if (!ZDSCFYSelectList?.length) {
                notification.info({
                  message: '请填写必填项【自动生成费用】',
                })
                return
              }
            }
            const commonParams = {
              // 自动生成费用中选中的治疗所有id
              treatmentServiceIds: treatmentServiceIds,

              // 自动生成费用中选中的药品所有id
              materialsCatalogIds: materialsCatalogIds,

              // 触发条件类型状态
              conditionType: values.conditionType,

              // 触发条件类型状态选择药品的所有药品id
              conditionMaterialsCatalogIds: conditionMaterialsCatalogIds,

              // 触发条件类型状态选择诊疗的所有诊疗id
              conditionTreatmentServiceIds: conditionTreatmentServiceIds,

              // 生成数量规则状态
              countType: values?.countType,

              // 触发条件类型状态 conditionType == 0 选中的normalUseMethodSelectList用法list
              conditionUsemethod:
                values.conditionType == 0 ? conditionUsemethod : '',

              // 触发条件类型状态 conditionType == 1 selectYPOrZLList 药品或诊疗list筛选出的name集合
              conditionDataName: conditionDataName,

              // 触发条件类型状态 conditionType == 1 selectYPOrZLList 药品或诊疗list
              conditionData: values.conditionType == 1 ? selectYPOrZLList : [],

              // 生成数量规则状态 固定数量时填写的数量
              projectCount: values.countType == 0 ? values.projectCount : 0,
            }

            const params = {
              ...commonParams,

              // 自动生成费用中选中的所有list
              projectData: ZDSCFYSelectList,

              // 自动生成费用中选中的所有list筛选出的name
              projectDataName: projectDataName,

              // 老数据用来跟之前的做对比，用作编辑前端暂存的数据 (editDetailMessage编辑的数据结构)

              // 触发条件类型状态
              oldConditionType: editDetailMessage.oldConditionType,

              // 自动生成费用中选中的所有list筛选出的name
              oldProjectDataName: editDetailMessage?.oldProjectDataName,

              // 自动生成费用中选中的所有list
              oldProjectData: editDetailMessage?.oldProjectData,

              // 触发条件类型状态 conditionType == 1 selectYPOrZLList 药品或诊疗list
              oldConditionData:
                values.conditionType == 1
                  ? editDetailMessage?.oldConditionData
                  : [],

              // 触发条件类型状态 conditionType == 1 selectYPOrZLList 药品或诊疗list筛选出的name集合

              oldConditionDataName:
                values.conditionType == 1
                  ? editDetailMessage.oldConditionDataName
                  : '',

              // 触发条件类型状态 conditionType == 0 选中的normalUseMethodSelectList用法list
              oldConditionUsemethod:
                values.conditionType == 0
                  ? editDetailMessage.oldConditionUsemethod
                  : '',
            }
            // 没落地的数据前端自行编辑
            onSuccess && onSuccess(params)
            
          })
        }}
      >
        <Form
          form={form}
          autoComplete='off'
          colon={false}
          labelAlign='right'
          initialValues={{ projectCount: 1 }}
          style={{ paddingRight: 40, position: 'relative' }}
        >
          <Row className={styles.chuFaType}>
            <Col span={24}>
              <Row style={{ display: 'flex' }}>
                <span
                  style={{
                    width: 140,
                    textAlign: 'right',
                    marginRight: 22,
                    lineHeight: '32px',
                  }}
                >
                  触发条件类型
                </span>
                <Form.Item
                  name='conditionType'
                  rules={[{ required: true, message: '请选择' }]}
                >
                  <Radio.Group
                    onChange={(v) => {
                      setState(v.target.value)
                    }}
                  >
                    <Radio value={0}>通过用法触发</Radio>
                    <Radio value={1}>指定项目触发</Radio>
                  </Radio.Group>
                </Form.Item>
              </Row>
            </Col>
          </Row>
          {state != 1 ? (
            <>
              <Row className={styles.chuFaType}>
                <Col span={24}>
                  <Row style={{ marginTop: 14, display: 'flex' }}>
                    <div
                      style={{
                        width: 140,
                        textAlign: 'right',
                        marginRight: 22,
                        lineHeight: '32px',
                      }}
                    >
                      触发以下用法时 →
                    </div>
                    <Form.Item style={{ flex: 1 }}>
                      <RecipeItemFieldInput
                        value={normalUsemethodValue}
                        field={'normalUsemethod'}
                        disabled={false}
                        noSize={true}
                        autoFocus={false}
                        placeholderInput='输入名称/助记码搜索'
                        onChange={(v, pc) => {
                          setNormalUsemethodValue(v)
                          if (pc) {
                            setNormalUseMethodSelectList(
                              normalUseMethodSelectList.concat([v])
                            )
                            setNormalUsemethodValue('')
                          }
                        }}
                        onPressEnter={(v) => {
                          if (v) {
                            setNormalUseMethodSelectList(
                              normalUseMethodSelectList.concat([v])
                            )
                            setNormalUsemethodValue('')
                          }
                          
                        }}
                      />
                    </Form.Item>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col style={{ marginLeft: 162 }}>
                  {normalUseMethodSelectList.map((d, index) => (
                    <div key={index} className={styles.disease}>
                      {d}
                      <CloseOutlined
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          const list = [...normalUseMethodSelectList]
                          list.splice(index, 1)
                          setNormalUseMethodSelectList(list)
                        }}
                      />
                    </div>
                  ))}
                </Col>
              </Row>
            </>
          ) : (
            <>
              <Row
                style={{ display: 'flex', alignItems: 'center', marginTop: 16 }}
              >
                <span style={{ width: 140, textAlign: 'right' }}>
                  开具以下项目时 →
                </span>
                <Select
                  style={{
                    color: theme.tc1,
                    fontSize: '1rem',
                    width: '5rem',
                    height: '2rem',
                    backgroundColor: theme.c3,
                    margin: '0 10px 0 22px',
                  }}
                  value={
                    completionTypeA === ItemCompletionType.Treatment ? 1 : 0
                  }
                  onChange={(v) => {
                    if (v === 1) {
                      setCompletionTypeA(ItemCompletionType.Treatment)
                    } else {
                      setCompletionTypeA(ItemCompletionType.Auto)
                    }
                  }}
                  // suffixIcon={<CaretDownFilled />}
                  bordered={false}
                  className={styles.select}
                >
                  <Select.Option value={0}>药品</Select.Option>
                  <Select.Option value={1}>诊疗</Select.Option>
                </Select>
                <RecipeItemInput
                  noSetting={true}
                  isRestrictUser={1} //是否限制用户
                  style={{
                    flex: 1,
                    height: '2rem',
                    color: theme.tc1,
                  }}
                  category={RecipeCategory.ShuZhuFang}
                  placeholder='输入名称/助记码搜索'
                  autoFocus={selectYPOrZLList?.length ? true : false}
                  type={completionTypeA}
                  value={YFInputValue}
                  useSpecifiedBatch={useSpecifiedBatch}
                  ignoreStorage={true}
                  onSelect={(m, ignoreStorage) => {
                    setYFInputValue('')
                    setSelectYPOrZLList(
                      selectYPOrZLList.concat([
                        {
                          id: m.id,
                          name: m.name,
                          catalogType:
                            completionTypeA == ItemCompletionType.Treatment
                              ? 2
                              : 1,
                        },
                      ])
                    )
                  }}
                  onChange={(v) => {
                    setYFInputValue(v)
                  }}
                />
              </Row>
              <Row>
                <Col style={{ marginLeft: 162 }}>
                  {selectYPOrZLList.map((d, index) => (
                    <div key={index} className={styles.disease}>
                      {d.name}
                      <CloseOutlined
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          const list = [...selectYPOrZLList]
                          list.splice(index, 1)
                          setSelectYPOrZLList(list)
                        }}
                      />
                    </div>
                  ))}
                </Col>
              </Row>
            </>
          )}
          <Row style={{ display: 'flex', alignItems: 'center', marginTop: 18 }}>
            <span style={{ width: 140, textAlign: 'right' }}>自动创建以下费用 →</span>
            <Select
              style={{
                color: theme.tc1,
                fontSize: '1rem',
                width: '5rem',
                height: '2rem',
                backgroundColor: theme.c3,
                margin: '0 10px 0 22px',
              }}
              value={completionType === ItemCompletionType.Treatment ? 1 : 0}
              onChange={(v) => {
                if (v === 1) {
                  setCompletionType(ItemCompletionType.Treatment)
                } else {
                  setCompletionType(ItemCompletionType.Auto)
                }
              }}
              bordered={false}
              className={styles.select}
            >
              <Select.Option value={0}>药品</Select.Option>
              <Select.Option value={1}>诊疗</Select.Option>
            </Select>
            <RecipeItemInput
              noSetting={true}
              isRestrictUser={1} //是否限制用户
              style={{
                flex: 1,
                height: '2rem',
                color: theme.tc1,
              }}
              category={RecipeCategory.ShuZhuFang}
              placeholder='输入名称/助记码搜索'
              autoFocus={ZDSCFYSelectList?.length ? true : false}
              type={completionType}
              value={ZDSCFYInput}
              useSpecifiedBatch={useSpecifiedBatch}
              ignoreStorage={true}
              onSelect={(m, ignoreStorage) => {
                setZDSCFYInput('')
                if (ZDSCFYSelectList?.length + 1 > 5) {
                  notification.info({
                    message: '自动生成费用最多添加5个',
                  })
                } else {
                  setZDSCFYSelectList(
                    ZDSCFYSelectList.concat([
                      {
                        id: m.id,
                        name: m.name,
                        catalogType:
                          completionType == ItemCompletionType.Treatment
                            ? 2
                            : 1,
                      },
                    ])
                  )
                }
              }}
              onChange={(v) => {
                setZDSCFYInput(v)
              }}
            />
          </Row>
          <Row>
            <Col style={{ marginLeft: 162 }}>
              {ZDSCFYSelectList?.map((d, index) => (
                <div key={index} className={styles.disease}>
                  {d.name}
                  <CloseOutlined
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      const list = [...ZDSCFYSelectList]
                      list.splice(index, 1)
                      setZDSCFYSelectList(list)
                    }}
                  />
                </div>
              ))}
            </Col>
          </Row>
          <Row className={styles.chuFaType}>
            <Col span={24}>
              <Row
                style={{ marginTop: 16, display: 'flex' }}
                className={styles.error}
              >
                <div
                  style={{
                    width: 140,
                    textAlign: 'right',
                    marginRight: 22,
                    lineHeight: '32px',
                  }}
                >
                  生成数量规则
                </div>
                <Form.Item
                  name='countType'
                  rules={[{ required: true, message: '请选择' }]}
                >
                  <Radio.Group>
                    <Radio value={0}>
                      <Row style={{ display: 'flex' }}>
                        <span style={{ paddingRight: 6, lineHeight: '32px' }}>
                          固定数量，数量为
                        </span>
                        <Form.Item
                          name='projectCount'
                          rules={[{ required: true, message: '请输入数量' }]}
                        >
                          <Input
                            style={{ width: 60 }}
                            onChange={(e) => {
                              const inputValue = e.target.value
                              // 只保留数字字符
                              const numericValue = inputValue.replace(/\D/g, '')
                              form.setFieldsValue({
                                projectCount: numericValue,
                              })
                            }}
                          />
                        </Form.Item>
                      </Row>
                    </Radio>
                    <Radio value={1}>数量等同天数</Radio>
                    <Radio value={2}>数量等同开方数量</Radio>
                  </Radio.Group>
                </Form.Item>
              </Row>
            </Col>
          </Row>
          <div style={{ position: 'absolute', bottom: -62, color: '#FFA073' }}>
            说明：自动生成费用的售价默认展示目录价
          </div>
        </Form>
      </Modal>
    </>
  )
}
